import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ConfirmDialog } from '../../../app/ConfirmDialog';
import { offline } from '../../../lib/api';
import { useLogout } from '../api';

/**
 * Sign-out for the user menu (desktop) and "Mehr" (phones): asks first when
 * captured entries have not been sent yet, because sign-out deletes them.
 */
export function useSignOut() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logout = useLogout();
  const [unsent, setUnsent] = useState(0);
  const signOut = () =>
    logout.mutate(undefined, {
      onSettled: () => navigate('/anmelden', { replace: true }),
    });
  const start = () =>
    void offline
      .pending()
      .then(
        (items) => items.length,
        () => 0,
      )
      .then((count) => (count > 0 ? setUnsent(count) : signOut()));
  const dialog = (
    <ConfirmDialog
      open={unsent > 0}
      onClose={() => setUnsent(0)}
      title={t('offline.logoutTitle')}
      description={t('offline.logoutText', { count: unsent })}
      confirmLabel={t('offline.logoutConfirm')}
      onConfirm={() => {
        setUnsent(0);
        signOut();
      }}
    />
  );
  return { start, dialog, pending: logout.isPending };
}
